(() => {
  if (window.customElements.get('homepage-product-carousel')) return;

  class HomepageProductCarousel extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-homepage-product-scroller]');
      this.previousButton = this.querySelector('[data-homepage-products-previous]');
      this.nextButton = this.querySelector('[data-homepage-products-next]');

      if (!this.scroller || !this.previousButton || !this.nextButton) return;

      this.handlePreviousClick = () => this.scrollByProduct(-1);
      this.handleNextClick = () => this.scrollByProduct(1);
      this.handleScroll = () => window.requestAnimationFrame(() => this.updateButtons());
      this.handlePointerEnter = () => this.updateButtons();

      this.previousButton.addEventListener('click', this.handlePreviousClick);
      this.nextButton.addEventListener('click', this.handleNextClick);
      this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
      this.addEventListener('pointerenter', this.handlePointerEnter);

      this.resizeObserver = new ResizeObserver(() => this.updateButtons());
      this.resizeObserver.observe(this.scroller);

      window.requestAnimationFrame(() => this.updateButtons());
    }

    disconnectedCallback() {
      if (!this.scroller) return;

      this.previousButton.removeEventListener('click', this.handlePreviousClick);
      this.nextButton.removeEventListener('click', this.handleNextClick);
      this.scroller.removeEventListener('scroll', this.handleScroll);
      this.removeEventListener('pointerenter', this.handlePointerEnter);
      this.resizeObserver?.disconnect();
    }

    getStep() {
      const firstProduct = this.scroller.querySelector('product-item');
      if (!firstProduct) return this.scroller.clientWidth;

      const styles = window.getComputedStyle(this.scroller);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      return firstProduct.getBoundingClientRect().width + gap;
    }

    scrollByProduct(direction) {
      const step = this.getStep();
      const maximumScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
      const currentIndex = Math.round(this.scroller.scrollLeft / step);
      const target = Math.min(maximumScroll, Math.max(0, (currentIndex + direction) * step));

      this.scroller.scrollTo({ left: target, behavior: 'smooth' });
    }

    updateButtons() {
      const maximumScroll = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
      const currentScroll = Math.max(0, this.scroller.scrollLeft);
      const threshold = 3;

      this.previousButton.disabled = currentScroll <= threshold;
      this.nextButton.disabled = currentScroll >= maximumScroll - threshold;
    }
  }

  window.customElements.define('homepage-product-carousel', HomepageProductCarousel);
})();
